"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVolumeStrategyValue = exports.getPriceSummaryForItem = exports.getQuoteSummaryForItem = void 0;
function getQuoteSummaryForItem(quoteSummary, type, id) {
    var e_1, _a, e_2, _b, e_3, _c;
    if (type === "page")
        return quoteSummary;
    try {
        for (var _d = __values(quoteSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
            var block = _e.value;
            if (type === "block" && block.id === id)
                return block;
            try {
                for (var _f = (e_2 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var section = _g.value;
                    if (type === "section" && section.id === id)
                        return section;
                    try {
                        for (var _h = (e_3 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var lineItem = _j.value;
                            if (type === "lineItem" && lineItem.id === id)
                                return lineItem;
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    throw new Error("Couldn't find ".concat(type, " with id ").concat(id, " in quoteSummary"));
}
exports.getQuoteSummaryForItem = getQuoteSummaryForItem;
var getPriceSummaryForItem = function (priceSummary, id) {
    var e_4, _a, e_5, _b, e_6, _c;
    if (!id)
        return priceSummary.total;
    try {
        for (var _d = __values(priceSummary.blocks), _e = _d.next(); !_e.done; _e = _d.next()) {
            var block = _e.value;
            if (id === block.id)
                return block.total;
            try {
                for (var _f = (e_5 = void 0, __values(block.sections)), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var section = _g.value;
                    if (id === section.id)
                        return section.total;
                    try {
                        for (var _h = (e_6 = void 0, __values(section.lineItems)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var lineItem = _j.value;
                            if (id === lineItem.id)
                                return lineItem.total;
                        }
                    }
                    catch (e_6_1) { e_6 = { error: e_6_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_6) throw e_6.error; }
                    }
                }
            }
            catch (e_5_1) { e_5 = { error: e_5_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_5) throw e_5.error; }
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return {};
};
exports.getPriceSummaryForItem = getPriceSummaryForItem;
var getVolumeStrategyValue = function (field, amount) {
    var e_7, _a;
    var result = field.baseValue;
    try {
        for (var _b = __values(field.tiers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var tier = _c.value;
            if (amount >= tier.minimumThreshold) {
                result = tier.value;
            }
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_7) throw e_7.error; }
    }
    return result;
};
exports.getVolumeStrategyValue = getVolumeStrategyValue;
